<template>
    <transition name="ipt-wrap">
      <div class="ipt-wrap" v-if="showIptWrap">
        <div class="inner">
          <p class="title">
            {{ title }}
          </p>
          <slot v-if="showIptWrap" />
          <div class="btn-box">
            <button class="cancel" @click="$emit('close-ipt-wrap')">取消</button>
            <button class="confirm" :class="{disabled: disabled}" :disabled="disabled" @click="$emit('confirm')">确认</button>
          </div>
        </div>
        <div class="mask"/>
      </div>
    </transition>
</template>

<script>
export default {
    props: {
      title: String,
      disabled: Boolean,
      showIptWrap: Boolean
    }
}
</script>

<style lang="scss" scoped>
.ipt-wrap {

  .mask {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .4);
    z-index: 99;
  }

  .inner {
    position: fixed;
    left: 50%;
    top: 10px;
    width: 94%;
    max-width: 651px;
    padding: 10px;
    transform: translateX(-50%);
    background: #FFFFFF;
    border-radius: 5px;
    z-index: 100;

    .title {
      padding: 3px 0 13px;
      color: #08A681;
      border-bottom: 2px solid #08A681;
    }
  }

  .btn-box {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
      flex: 1;
      height: 50px;
      box-sizing: border-box;
      border-radius: 5px;
      font-size: 16px;
      font-weight: bold;

      &.cancel {
        margin-right: 2.53%;
        background: #fff;
        color: #666666;
        border: 1px solid #999999;
      }

      &.confirm {
        color: #fff;
        background: #08A681;
        box-shadow: 0 2px 5px 0 rgba(0,150,136,0.60);

        &.disabled {
          background: #CCCCCC;
          box-shadow: none;
        }
      }
    }
  }
}

.ipt-wrap-enter,
.ipt-wrap-leave-to {
  opacity: 0;
}

.ipt-wrap-enter-active,
.ipt-wrap-leave-active {
  transition: opacity .25s;
}
</style>
